const { equals, init, last, pipe, prop, split, complement, concat, ifElse, } = require("ramda")
// const testList = [
//   {
//     "frontmatter": {
//       "puesto": 99,
//       "title": "Automatización de procesos",
//       "avatar": "brain",
//       "galeria": null,
//       "imagen": null
//     },
//     "slug": "automatizacion/automatizacion",
//     "excerpt": "Roboticemos todo.",
//     "id": "51c2f231-a28f-5683-9f55-1849c87df204"
//   },
//   {
//     "frontmatter": {
//       "puesto": 99,
//       "title": "Horquilla vibrante",
//       "avatar": null,
//       "galeria": null,
//       "imagen": null
//     },
//     "slug": "instrumental/hrqvib-07series",
//     "excerpt": "Horquilla vibrante 07 series",
//     "id": "bca89763-5eb4-543d-8516-029d27b78cb9"
//   },
//   {
//     "frontmatter": {
//       "puesto": 99,
//       "title": "Instrumentos para la industria",
//       "avatar": "gauge",
//       "galeria": null,
//       "imagen": null
//     },
//     "slug": "instrumental/instrumental",
//     "excerpt": "Caudalímetros. Transmisores de presión. Rotámetros. Paletas rotativas. \nSensores electromecánicos de nivel. Horquillas vibrantes. \nDisplays digitales de presión. Dataloggers de presión. Detectores flotantes de nivel.",
//     "id": "8a6f9baa-49e6-57e7-80f5-0f71d297ba2e"
//   },
//   {
//     "frontmatter": {
//       "puesto": 99,
//       "title": "Herrajes y morsetos",
//       "avatar": "clamp",
//       "galeria": null,
//       "imagen": null
//     },
//     "slug": "morseteria/morseteria",
//     "excerpt": "Para apretar bien fuerte",
//     "id": "89efbc56-e307-5034-bc20-d4d7039be7df"
//   },
//   {
//     "frontmatter": {
//       "puesto": 99,
//       "title": "Caudalímetro KF600",
//       "avatar": null,
//       "galeria": null,
//       "imagen": null
//     },
//     "slug": "instrumental/caudalimetros/caud-kf600",
//     "excerpt": "Placa Orificio KF600 Hello,  The span above will read: \"Hello, World\".",
//     "id": "a1e37a1e-9a09-59dd-bae1-882a9ed40676"
//   },
//   {
//     "frontmatter": {
//       "puesto": 99,
//       "title": "Caudalímetro LD",
//       "avatar": null,
//       "galeria": [
//         {
//           "descripcion": "",
//           "source": {
//             "childImageSharp": {
//               "fixed": {
//                 "base64": "data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAVABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAQFAQb/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB1Y4eXPpUKKtzBNED/8QAGxAAAgMAAwAAAAAAAAAAAAAAAgMAAQQREiL/2gAIAQEAAQUCc8FRPazjfbwu1FmImK4qPzhAGgH/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAWEQEBAQAAAAAAAAAAAAAAAAAQARH/2gAIAQIBAT8Bwh//xAAdEAACAgIDAQAAAAAAAAAAAAAAAQIREjEQISJx/9oACAEBAAY/Aqb7E87X3iWR5ZlZouKqxRWkf//EABsQAAIDAQEBAAAAAAAAAAAAAAERACExQRBR/9oACAEBAAE/IRDQIc5FvftM/CONenkSV/VGQVkpwmbAvaggDEkVMSRT/9oADAMBAAIAAwAAABB/J3z/xAAXEQADAQAAAAAAAAAAAAAAAAABEBFB/9oACAEDAQE/ELpRX//EABgRAQEAAwAAAAAAAAAAAAAAAAEAEBEh/9oACAECAQE/EDnQySRx/8QAIBABAQACAQMFAAAAAAAAAAAAAREAIVEQMXFBYYGxwf/aAAgBAQABPxBCtURfYvzhIbIbDlb0EzIwBgNH5keZLXT5wRDEt1D1+8LBQlBvnBudxzR1zrC+ghn/2Q==",
//                 "width": 400,
//                 "height": 422,
//                 "src": "/static/9fb30d659986632abcca620b76fc026a/2244e/01.jpg",
//                 "srcSet": "/static/9fb30d659986632abcca620b76fc026a/2244e/01.jpg 1x"
//               }
//             }
//           }
//         },
//         {
//           "descripcion": "",
//           "source": {
//             "childImageSharp": {
//               "fixed": {
//                 "base64": "data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAARABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAMEBQIG/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAHmaStqegZLN1qAXwf/xAAbEAACAwADAAAAAAAAAAAAAAABAwACBBMUM//aAAgBAQABBQLQ+xvjebGOzEnrlS+JlzNvjP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB4QAAEDBAMAAAAAAAAAAAAAAAEAEBECISIxUYKR/9oACAEBAAY/Aop1woOmxHik2ErGaQ3YN//EABoQAQEAAwEBAAAAAAAAAAAAAAERABAhMfD/2gAIAQEAAT8hX0RYMGIq41s1SW7RUTJDkgi4oMjks14/Hdf/2gAMAwEAAgADAAAAEJMoPP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABcRAQADAAAAAAAAAAAAAAAAAAEAELH/2gAIAQIBAT8QyBf/xAAeEAEAAgEEAwAAAAAAAAAAAAABABEhMUFRgRCh8P/aAAgBAQABPxC/RAt0NVrXmMMijIZRN6wwRLMjGqKIZY2lpeFNtuc+owbmRXd0O66jPl8PH//Z",
//                 "width": 400,
//                 "height": 344,
//                 "src": "/static/72623bf182b5480ffc431fac1a805326/2244e/02.jpg",
//                 "srcSet": "/static/72623bf182b5480ffc431fac1a805326/2244e/02.jpg 1x"
//               }
//             }
//           }
//         },
//         {
//           "descripcion": "",
//           "source": {
//             "childImageSharp": {
//               "fixed": {
//                 "base64": "data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAUGBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHfhZTtVYkEdT9EjHgEv//EABsQAQADAAMBAAAAAAAAAAAAAAIBAxIAESIT/9oACAEBAAEFAncsw88Chm8efXKItxYsDzo9ZRhRNc/YnJ//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAXEQADAQAAAAAAAAAAAAAAAAAAAhEQ/9oACAECAQE/AYQXP//EAB0QAAICAgMBAAAAAAAAAAAAAAABAhEhMRASIkH/2gAIAQEABj8CflwZaeRSRKUdmDxovhddFMcUsXViS+H/xAAZEAADAQEBAAAAAAAAAAAAAAAAAREhMUH/2gAIAQEAAT8hZW/AvpRTA0jGPbh44PcVQbapRUmwaS3Wrp5zOQY+LLjY8PdFc0kP/9oADAMBAAIAAwAAABAQ/sD/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREQMf/aAAgBAwEBPxBucKPP/8QAGBEBAQEBAQAAAAAAAAAAAAAAAREAITH/2gAIAQIBAT8QBK5N90Xrnf/EABwQAQEAAgMBAQAAAAAAAAAAAAERACExQVFhkf/aAAgBAQABPxCo1pzI9PMUTkrFf3DZI9dPZjxO6QbCa7xKhRq41NXfrC4gVY1Zzg6EsnD6ZsSEEjUwgl5gZi5xKnSNpdwyk0Auf//Z",
//                 "width": 292,
//                 "height": 450,
//                 "src": "/static/c45533d9b1ba76e42a78c674a4987fc4/48e00/03.jpg",
//                 "srcSet": "/static/c45533d9b1ba76e42a78c674a4987fc4/48e00/03.jpg 1x"
//               }
//             }
//           }
//         },
//         {
//           "descripcion": "",
//           "source": {
//             "childImageSharp": {
//               "fixed": {
//                 "base64": "data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABQADBP/EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEAMQAAABV4SsEfgrN//EABoQAAIDAQEAAAAAAAAAAAAAAAACAQMRBBT/2gAIAQEAAQUCsuRD1E9RY8s2ybp//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFREBAQAAAAAAAAAAAAAAAAAAECH/2gAIAQIBAT8Bh//EABkQAAIDAQAAAAAAAAAAAAAAABARAQIhMf/aAAgBAQAGPwJPTaX0/wD/xAAbEAADAAMBAQAAAAAAAAAAAAAAAREhMaFBUf/aAAgBAQABPyHOK+EWq1rwTddFEwcfCGan/9oADAMBAAIAAwAAABDTz//EABYRAQEBAAAAAAAAAAAAAAAAAAARIf/aAAgBAwEBPxDVf//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAgEBPxDS1//EAB0QAQACAwADAQAAAAAAAAAAAAEAIRExUWFxkbH/2gAIAQEAAT8QZWe3ZWgp2ugt/PsLhzesdFd1hDkVkWqPByKaxl1P/9k=",
//                 "width": 400,
//                 "height": 300,
//                 "src": "/static/42e56c28a4debf4f7f77138c270bf5f3/2244e/04.jpg",
//                 "srcSet": "/static/42e56c28a4debf4f7f77138c270bf5f3/2244e/04.jpg 1x,\n/static/42e56c28a4debf4f7f77138c270bf5f3/4fe8c/04.jpg 1.5x"
//               }
//             }
//           }
//         },
//         {
//           "descripcion": "",
//           "source": {
//             "childImageSharp": {
//               "fixed": {
//                 "base64": "data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAYABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAQBAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAADAQL/2gAMAwEAAhADEAAAAZaIfSo40WIeo1qBT//EABkQAAMBAQEAAAAAAAAAAAAAAAACEQEhEP/aAAgBAQABBQKkjGdLlFXq+f/EABYRAQEBAAAAAAAAAAAAAAAAAAEQEf/aAAgBAwEBPwFTIz//xAAbEQACAQUAAAAAAAAAAAAAAAAAAQIDEBETMf/aAAgBAgEBPwHW8WpzfBs//8QAGxAAAQQDAAAAAAAAAAAAAAAAAQAQIVERMUH/2gAIAQEABj8CGbRFNKJ6W3D/AP/EAB4QAAMAAgEFAAAAAAAAAAAAAAABESFRMUFhcZGh/9oACAEBAAE/IZT6UXwNErTEMqfwNrqusRl2I9j578F0f//aAAwDAQACAAMAAAAQxMfC/8QAGREAAwADAAAAAAAAAAAAAAAAAAERECFB/9oACAEDAQE/EFI6U3Vx/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARIf/aAAgBAgEBPxAbUicYGRFVv//EABsQAQEBAQADAQAAAAAAAAAAAAERACExQVGh/9oACAEBAAE/EKJdwXrXcm0UYrD1+Y5z6yDR8jNUOVXhPbuimm0JMlrdwcTA/MQAoG//2Q==",
//                 "width": 400,
//                 "height": 483,
//                 "src": "/static/dd984d7b56b5f35cc33e314487b72408/2244e/05.jpg",
//                 "srcSet": "/static/dd984d7b56b5f35cc33e314487b72408/2244e/05.jpg 1x,\n/static/dd984d7b56b5f35cc33e314487b72408/4fe8c/05.jpg 1.5x"
//               }
//             }
//           }
//         }
//       ],
//       "imagen": {
//         "descripcion": "Caudalímetro LD",
//         "source": {
//           "childImageSharp": {
//             "fixed": {
//               "base64": "data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAWABQDASIAAhEBAxEB/8QAGgABAAIDAQAAAAAAAAAAAAAAAAMFAQIEBv/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAG5pYN69IoBnoEmEv8A/8QAHBAAAQQDAQAAAAAAAAAAAAAAAwECBBEAEhQT/9oACAEBAAEFAjWoo719MQ7kzWhR5GguXc/ClCiMY3//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAWEQADAAAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8BI//EAB0QAAICAgMBAAAAAAAAAAAAAAARAQIhMQMQEjL/2gAIAQEABj8Ct52iMXlb65FZSy0+95Qjkq1B9inMn//EABwQAAMBAAIDAAAAAAAAAAAAAAABESExcUFRkf/aAAgBAQABPyFVdViGGrRri7E7wUjBS8469uyY9xi8kjf01qrMwoXa0//aAAwDAQACAAMAAAAQY8d+/8QAFhEAAwAAAAAAAAAAAAAAAAAAASAh/9oACAEDAQE/EBU//8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERYf/aAAgBAgEBPxCaUVorP//EABwQAQEAAgMBAQAAAAAAAAAAAAERADEhQWGBUf/aAAgBAQABPxAS2wrG+YSQmIBtNvz3AAoR0mDqxG9lvfeUJSU09/XOQA1O8CGCkK9jj7jH1wpg+5UpqRDP/9k=",
//               "width": 400,
//               "height": 449,
//               "src": "/static/d4ee46e718ae18c2d3371bc72c00db9f/2244e/grande.jpg",
//               "srcSet": "/static/d4ee46e718ae18c2d3371bc72c00db9f/2244e/grande.jpg 1x"
//             }
//           }
//         }
//       }
//     },
//     "slug": "instrumental/caudalimetros/caud-ld",
//     "excerpt": "Caudalímetro electromagnético.",
//     "id": "72c4405f-e966-505e-bd21-e4ca8f72b235"
//   },
//   {
//     "frontmatter": {
//       "puesto": 0,
//       "title": "Caudalímetros",
//       "avatar": null,
//       "galeria": null,
//       "imagen": null
//     },
//     "slug": "instrumental/caudalimetros/caudalimetros",
//     "excerpt": "Todo caudalímetros.",
//     "id": "a325e91f-c6bd-5767-8a00-97c82ce42d94"
//   },
//   {
//     "frontmatter": {
//       "puesto": 99,
//       "title": "Redes Aéreas de Media y Alta tensión",
//       "avatar": "electric-tower",
//       "galeria": null,
//       "imagen": null
//     },
//     "slug": "morseteria/redesaltaymediatension/redesaltaymediatension",
//     "excerpt": "Conjunto de accesorios para conductor desnudo. Accesorios para cable de guardia.",
//     "id": "73984e7c-1b19-5f2f-935b-2c815a20a2bc"
//   },
//   {
//     "frontmatter": {
//       "puesto": 99,
//       "title": "Conjunto de accesorios para conductor desnudo",
//       "avatar": null,
//       "galeria": [
//         {
//           "descripcion": "",
//           "source": {
//             "childImageSharp": {
//               "fixed": {
//                 "base64": "data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQBAgP/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFmHMxgsH//xAAZEAEBAAMBAAAAAAAAAAAAAAABAgADERL/2gAIAQEAAQUC9X2qc0vYp5iFmsCf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGxAAAgIDAQAAAAAAAAAAAAAAABEBAhAiYYH/2gAIAQEABj8C2pPgqt9ypFB//8QAGxAAAwACAwAAAAAAAAAAAAAAAAERIXEQMZH/2gAIAQEAAT8hdXrDDSN2GZfd4DunGybIj//aAAwDAQACAAMAAAAQvM//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAdEAEAAwABBQAAAAAAAAAAAAABABEhUWFxgZHR/9oACAEBAAE/EM2a40exFBnyE++I+xRiO0kBDWvWKhsbVH3AVIcJ/9k=",
//                 "width": 400,
//                 "height": 259,
//                 "src": "/static/1eda5dd6136cff1c9e936fa19423a5bb/2244e/13.1.jpg",
//                 "srcSet": "/static/1eda5dd6136cff1c9e936fa19423a5bb/2244e/13.1.jpg 1x"
//               }
//             }
//           }
//         },
//         {
//           "descripcion": "",
//           "source": {
//             "childImageSharp": {
//               "fixed": {
//                 "base64": "data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMCBAX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHQU5JeJh//xAAaEAACAwEBAAAAAAAAAAAAAAABAgADITEz/9oACAEBAAEFArHgJWIMsXfSJz//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAdEAACAQQDAAAAAAAAAAAAAAAAASEQERJBIjGB/9oACAEBAAY/ArKWc49NmS7Enqn/xAAbEAEAAgMBAQAAAAAAAAAAAAABABExQVEhkf/aAAgBAQABPyFza6vECBNsJHT9QRMlI8g9QVP/2gAMAwEAAgADAAAAEI8P/8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQMBAT8QZ//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABwQAQACAgMBAAAAAAAAAAAAAAEAESFRMUFxYf/aAAgBAQABPxBF6kGnp0QRQqQTzOYbe7O0F6MjkQ+RXsqwHlgGG5//2Q==",
//                 "width": 400,
//                 "height": 266,
//                 "src": "/static/7c8ea6ee03b2b8723f1017d9c26e7199/2244e/13.2.jpg",
//                 "srcSet": "/static/7c8ea6ee03b2b8723f1017d9c26e7199/2244e/13.2.jpg 1x"
//               }
//             }
//           }
//         },
//         {
//           "descripcion": "",
//           "source": {
//             "childImageSharp": {
//               "fixed": {
//                 "base64": "data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAMABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHc09a1FE//xAAZEAADAQEBAAAAAAAAAAAAAAABAhEAAxP/2gAIAQEAAQUCfsENYslnmrnXf//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABoQAAICAwAAAAAAAAAAAAAAAAABECEREjH/2gAIAQEABj8CwzjLNmrn/8QAGhABAQACAwAAAAAAAAAAAAAAAQARUSExQf/aAAgBAQABPyFanMOhuzmA3xhGq69hbv/aAAwDAQACAAMAAAAQwA//xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAwEBPxCH/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGxABAAMBAAMAAAAAAAAAAAAAAQARIUExgZH/2gAIAQEAAT8QuIDg7BWygJgyq01xWLTADlDnT3ARQgPBkCYvhP/Z",
//                 "width": 400,
//                 "height": 248,
//                 "src": "/static/8e2ac95f3276ee3bc1a9af3697151176/2244e/13.3.jpg",
//                 "srcSet": "/static/8e2ac95f3276ee3bc1a9af3697151176/2244e/13.3.jpg 1x"
//               }
//             }
//           }
//         }
//       ],
//       "imagen": {
//         "descripcion": "Conjunto de accesorios para conductor desnudo",
//         "source": {
//           "childImageSharp": {
//             "fixed": {
//               "base64": "data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAnABQDASIAAhEBAxEB/8QAGQABAQADAQAAAAAAAAAAAAAAAAQBAgMF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAacW8VpCR61ciwHlWi0hP//EABwQAAICAgMAAAAAAAAAAAAAAAECABEDEiIjMv/aAAgBAQABBQLZ7ZjMJtDG1cY9QuQ256gnlqM42htXRncKoNz/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AV//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AV//xAAfEAABBAEFAQAAAAAAAAAAAAARAAEQIQISIjFhgeH/2gAIAQEABj8C3YP46GLOe5Dqlo4TCzFr7BbKkRH/xAAcEAEAAwEAAwEAAAAAAAAAAAABABEhMRBBUXH/2gAIAQEAAT8hbUZg/RaJsvbmdycVpjp4Imx+2+w3EhVS+LjnHdp9grCPhDnsDUCHJ//aAAwDAQACAAMAAAAQuMnw9A//xAAXEQEAAwAAAAAAAAAAAAAAAAAAAREg/9oACAEDAQE/EMUl/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxBf/8QAIRABAAIBBAIDAQAAAAAAAAAAAQARITFBYXFRkYGhsdH/2gAIAQEAAT8QxcVuSPRGNk+QP7HzlEIt0k19QytxJtFoKP5ZAFYuAGPCBBGiPBMxQDH5IrDzGyRXpmeI5oh1UqQVdYh8Sxiqa+9vcxicS7PMrFjoJ//Z",
//               "width": 400,
//               "height": 777,
//               "src": "/static/e7a80673512b127138b71020b2839717/2244e/13.jpg",
//               "srcSet": "/static/e7a80673512b127138b71020b2839717/2244e/13.jpg 1x"
//             }
//           }
//         }
//       }
//     },
//     "slug": "morseteria/redesaltaymediatension/acccd",
//     "excerpt": "Conjuntos de suspensión y retención del cable aéreo desnudo,\npara simple o doble cadena de aisladores,\ncon o sin protección:  Estribos simples y dobles.  Péndulos de distintas medidas  Anillos con ojal  Anillos con badajo planos  Anillos con badajo planos…",
//     "id": "6da2a593-05ef-504f-a49f-b3b0a14ca962"
//   }
// ]
// const testList = [
//   {
//     frontmatter: {
//       title: "Automatización de procesos",
//     },
//     slug: "automatizacion/automatizacion",
//     excerpt:
//       "E",
//     id: "51c2f231-a28f-5683-9f55-1849c87df204",
//   },
//   {
//     frontmatter: {
//       title: "Horquilla vibrante",
//     },
//     slug: "instrumental/hrqvib-07series",
//     excerpt: "Horquilla vibrante 07 series",
//     id: "bca89763-5eb4-543d-8516-029d27b78cb9",
//   },
//   {
//     frontmatter: {
//       title: "Caudalímetro LD",
//     },
//     slug: "instrumental/caudalimetros/caud-ld",
//     excerpt: "Caudalímetro electromagnético.",
//     id: "72c4405f-e966-505e-bd21-e4ca8f72b235",
//   },
//   {
//     frontmatter: {
//       title: "Herrajes y morsetos",
//     },
//     slug: "morseteria/morseteria",
//     excerpt: "Para apretar bien fuerte",
//     id: "89efbc56-e307-5034-bc20-d4d7039be7df",
//   },
//   {
//     frontmatter: {
//       title: "Caudalímetro KF600",
//     },
//     slug: "instrumental/caudalimetros/caud-kf600",
//     excerpt:
//       'Placa Orificio KF600 Hello,  The span above will read: "Hello, World".',
//     id: "a1e37a1e-9a09-59dd-bae1-882a9ed40676",
//   },
//   {
//     frontmatter: {
//       title: "Instrumentos para la industria",
//     },
//     slug: "instrumental/caudalimetros/caudalimetros",
//     excerpt: "Todo caudalímetros. my image",
//     id: "a325e91f-c6bd-5767-8a00-97c82ce42d94",
//   },
//   {
//     frontmatter: {
//       title: "Instrumentos para la industria",
//     },
//     slug: "instrumental/instrumental",
//     excerpt:
//       "Caudalímetros. Transmisores de presión. Rotámetros. Paletas rotativas. \nSensores electromecánicos de nivel. Horquillas vibrantes. \nDisplays digitales de presión. Dataloggers de presión. Detectores flotantes de nivel.",
//     id: "8a6f9baa-49e6-57e7-80f5-0f71d297ba2e",
//   },
// ]

const sameName         = pipe(split("/"), x => equals(last(x), last(init(x))))
const isSibling        = (less, more) => equals(init(less), init(more))
const isChild          = (less, more) => {
    const fst = equals(init(less), [""]) ? [] : init(less)
    const es = equals(fst, init(init(more))); 
    return es
}
const siblings         = (o, os)      => os.filter(x => isSibling(split("/", o.slug), pipe(prop("slug"), split("/"))(x)) )
const siblingsNotMe    = (o, os)      => siblings(o,os).filter(x => complement(sameName)(x.slug))
const children         = (o, os)      => os.filter(x=>isChild(split("/",o.slug),split("/",x.slug)))
const categoryChildren = (o, os)      => children(o,os).filter(x => sameName(x.slug))
const isGroup          = (o, os)      => sameName(o.slug)
const laLista          = (o, os)      => concat(siblingsNotMe(o, os), categoryChildren(o, os))
const myList          = ifElse(isGroup, laLista, _ => [])
// testList.forEach(o => {
//     console.log("------------------------------------------------------------")
//     console.log(o.slug, o.frontmatter.title)
//     console.log(o.excerpt)
//     console.log()
//     console.log(miLista(o,testList))
//     console.log("------------------------------------------------------------")
//     console.log()
// })
// console.log(children({slug:"morseteria/morseteria"},testList))

module.exports = {myList, sameName, siblings, siblingsNotMe}
